import React from 'react'
import './SCSS/Style.scss';
import Home from './Components/Home';

function App() {
  return (
    <div className="App">
        <Home/>
    </div>
  );
}

export default App;
